import './index.less';
import * as React from 'react';
import { TableProps } from 'modules/types/commons/table';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Table, Pagination, BlockWithLoading } from '@beehive/components';
import { Notification } from '@bedrock/components';
import NoData from '../NoData';
import FilterRow from '../FilterRow';
import moment from 'moment';
import { localPx2rem } from '@mpc/common/src/';

export interface ListProps {
  prefixCls?: string;
  className?: string;
  hasFilter?: boolean;
  hasPagination?: boolean;
  tableProps: TableProps<any>;
  filterProps: any;
  paginationProps: any;
  blockWithLoadingProps: any;
  bottomSlot?: React.ReactNode;
  suppliersList: Array<Record<string, any>>;
}

class List extends React.PureComponent<ListProps, any> {
  public static defaultProps = {
    prefixCls: 'mpc-list',
    hasFilter: true,
    hasPagination: true,
    tableProps: {},
    filterProps: {},
    paginationProps: {},
    blockWithLoadingProps: {},
  };

  // TODO:温馨提醒暂时注释 防止后续要用
  // state = {
  //   isFirstUpdate: true
  // }
  // openNotification = (type: string, message: string) => {
  //   Notification[type]({
  //     message,
  //     className: 'mpc-list-notification',
  //     description: 'MPC系统已升级，您可点击右上角头像，通过“切换供应商身份”，选择不同服务类型来查看和处理需求。如无对应入口请忽略。',
  //     // duration: 10,
  //     // onClose: (e: any) => {
  //     //   const today = moment().startOf('day').format('YYYY-MM-DD');
  //     //   window.localStorage.setItem('today', today)
  //     // },
  //   });
  // };

  // componentDidMount(): void {
  //   this.setState({ isFirstUpdate: true })
  // }


  // componentDidUpdate(prevProps: Readonly<ListProps>, prevState: Readonly<any>, snapshot?: any): void {
  //   const { suppliersList } = this.props;
  //   if (this.state.isFirstUpdate && suppliersList?.length > 1) {
  //     const supplier = suppliersList.find((v: any) => v.is_new);
  //     if (supplier?.is_new) {
  //       this.openNotification('warning', '温馨提示')
  //     }
  //     this.setState({ isFirstUpdate: false })
  //   }
  // }

  // componentDidUpdate(prevProps: Readonly<ListProps>, prevState: Readonly<any>, snapshot?: any): void {
  //   const { suppliersList } = this.props;
  //   if (this.state.isFirstUpdate && suppliersList?.length) {
  //     const supplier = suppliersList.find((v: any) => v.selected);
  //     if (supplier?.uploaded_qualification_docs) {
  //       const day = moment().startOf('day').format('YYYY-MM-DD');
  //       const today = window.localStorage.getItem('today');
  //       if (!today) {
  //         this.openNotification('warning', '温馨提示')
  //       } else if (today && today !== day) {
  //         this.openNotification('warning', '温馨提示')
  //       }
  //     }
  //     this.setState({ isFirstUpdate: false })
  //   }
  // }


  public render() {
    const {
      prefixCls,
      className,
      blockWithLoadingProps,
      tableProps,
      filterProps,
      paginationProps,
      hasFilter,
      hasPagination,
      bottomSlot,
    } = this.props;

    const { data } = tableProps;
    const classes = classnames(className, {
      [`${prefixCls}-with-loading`]: true,
      [`${prefixCls}-with-filter`]: hasFilter,
      [`${prefixCls}-with-pagination`]: hasPagination,
    });

    return (
      <div className={classes}>
        {hasFilter && <FilterRow {...filterProps} />}
        <BlockWithLoading
          isInit={!data}
          spinSize={'large'}
          getContent={() => {
            if (data && data.length) {
              return (
                <React.Fragment>
                  <Table size="large" {...tableProps} />
                  <div className={`${prefixCls}-with-loading-bottom`}>
                    {bottomSlot && (
                      <div className={`${prefixCls}-with-loading-bottom-slot`}>{bottomSlot}</div>
                    )}
                    {hasPagination && <Pagination pageSizeOptions={[10, 15, 30, 50]} {...paginationProps} />}
                  </div>
                </React.Fragment>
              );
            } else {
              return (
                <div
                  className={`${prefixCls}-no-data`}
                  style={{ minHeight: localPx2rem(250), position: 'relative' }}
                >
                  <NoData type="empty" />
                </div>
              );
            }
          }}
          {...blockWithLoadingProps}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    suppliersList: state.account.suppliersList,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(List);
